import DuitkuPaymentForm from "@/modules/billing/duitku/DuitkuPaymentForm.tsx";
import { linkDefaults } from "@/modules/billing/paymentMethodDefaults.tsx";
import type { LinkMethod } from "@/modules/billing/paymentMethods.ts";
import type { ProcessorConfig } from "@warrenio/api-spec/spec.oats.gen";

export function makeDuitkuLink(config: ProcessorConfig & { type: "link" }) {
    return config.methods.map((method): LinkMethod => {
        const base = linkDefaults(config, method);
        return {
            ...base,
            PaymentForm: (props) => <DuitkuPaymentForm {...props} method={method} config={config} />,
        };
    });
}
